export interface TimelineItem {
  date: string;
  tag: string;
  tagColor: string;
  title: string;
  desc: string;
}

export const timeline: TimelineItem[] = [
  {
    date: '2026.09.02',
    tag: '站点状态',
    tagColor: 'bg-accent-100 text-accent-800',
    title: '全站完成例行安全巡检',
    desc: '本次巡检覆盖首页入口、验证页与内容展示链路，确认官网页面访问稳定，暂未发现异常挂载。',
  },
  {
    date: '2026.08.18',
    tag: '安全提醒',
    tagColor: 'bg-primary-100 text-primary-800',
    title: '再次提示：认准域名前缀与认证标识',
    desc: '近期发现个别相似域名冒充本站。请在地址栏核对官方域名，并在进入前确认页面右下角的唯一认证角标。',
  },
  {
    date: '2026.08.05',
    tag: '入口更新',
    tagColor: 'bg-secondary-100 text-secondary-800',
    title: '正版入口已切换至最新访问通道',
    desc: '为了提升访问速度与稳定性，官网已启用新的正式访问通道，旧地址自动跳转，无需手动更换收藏夹。',
  },
  {
    date: '2026.07.21',
    tag: '访问提示',
    tagColor: 'bg-accent-100 text-accent-800',
    title: '移动端与桌面端浏览建议',
    desc: '建议使用系统自带浏览器进入官网，避免第三方内置浏览内核拦截页面；如遇空白，可清理缓存后重试。',
  },
  {
    date: '2026.07.08',
    tag: '认证公告',
    tagColor: 'bg-primary-100 text-primary-800',
    title: '唯一官方认证标识说明发布',
    desc: '官方统一采用红色封签式认证角标，页面刷新后显示于首页右上角，其余样式均不属于官方认证范围。',
  },
];

export interface ChannelItem {
  title: string;
  en: string;
  brief: string;
  count: string;
  image: string;
}

export const channels: ChannelItem[] = [
  {
    title: '热榜快讯',
    en: 'TRENDING',
    brief: '滚动更新的热点速览，按热度实时排序，一眼掌握当日风向。',
    count: '实时更新',
    image: 'https://readdy.ai/api/search-image?query=warm%20amber%20newsroom%20editorial%20collage%20with%20glowing%20ranking%20screens%20and%20subtle%20film%20grain%2C%20magazine%20layout%2C%20soft%20paper%20background%2C%20cinematic%20low%20light%2C%20rich%20neutral%20tones&width=900&height=600&seq=chigualu-chan-01&orientation=landscape',
  },
  {
    title: '现场瞬间',
    en: 'SCENE',
    brief: '红毯、舞台与后台的抓拍记录，用画面定格容易被忽略的细节。',
    count: '图文结合',
    image: 'https://readdy.ai/api/search-image?query=candid%20backstage%20gala%20scene%20with%20warm%20spotlights%20and%20stage%20lights%20bokeh%2C%20editorial%20photography%2C%20soft%20grain%2C%20cinematic%20warm%20tones%2C%20magazine%20spread&width=900&height=600&seq=chigualu-chan-02&orientation=landscape',
  },
  {
    title: '深读长文',
    en: 'FEATURE',
    brief: '跳出片段还原脉络的长篇梳理，把零散信息连成完整叙事。',
    count: '独家策划',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20open%20editorial%20magazine%20pages%20with%20serif%20typography%20on%20warm%20cream%20paper%2C%20soft%20window%20light%2C%20documentary%20still%20life%2C%20minimal%20composition&width=900&height=600&seq=chigualu-chan-03&orientation=landscape',
  },
  {
    title: '数据盘点',
    en: 'DATA',
    brief: '以图表与数字拆解事件热度曲线，用可视化的方式辅助判断。',
    count: '可视化',
    image: 'https://readdy.ai/api/search-image?query=warm%20minimal%20charts%20and%20trend%20lines%20on%20paper%2C%20data%20visualization%20editorial%2C%20soft%20neutral%20palette%2C%20archival%20print%20texture%2C%20clean%20composition&width=900&height=600&seq=chigualu-chan-04&orientation=landscape',
  },
  {
    title: '互动圆桌',
    en: 'TALK',
    brief: '围绕当下话题开放的讨论场，供读者交流看法与补充分享。',
    count: '读者参与',
    image: 'https://readdy.ai/api/search-image?query=roundtable%20conversation%20over%20warm%20coffee%20in%20an%20editorial%20studio%2C%20muted%20warm%20tones%2C%20documentary%20photography%2C%20soft%20shadows%2C%20magazine%20feature%20still&width=900&height=600&seq=chigualu-chan-05&orientation=landscape',
  },
  {
    title: '深读·合辑',
    en: 'ARCHIVE',
    brief: '将历史事件按专题归档成册，需要时可按时间回溯检索。',
    count: '专题归档',
    image: 'https://readdy.ai/api/search-image?query=stacked%20vintage%20archival%20binders%20and%20newspapers%20on%20wooden%20shelf%2C%20warm%20dusty%20light%2C%20editorial%20documentary%2C%20soft%20neutral%20tones%2C%20quiet%20composition&width=900&height=600&seq=chigualu-chan-06&orientation=landscape',
  },
];

export interface GuideStep {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export const guideSteps: GuideStep[] = [
  {
    step: '01',
    title: '核对入口',
    desc: '从地址栏直接输入官方域名，或使用上方「直达官方地址」按钮，切勿通过来源不明的转发链接进入。',
    icon: 'ri-map-pin-line',
  },
  {
    step: '02',
    title: '确认认证角标',
    desc: '进入首页后，于右上角确认红色封签式唯一认证标识，标识颜色与样式请对照本站认证图样。',
    icon: 'ri-shield-check-line',
  },
  {
    step: '03',
    title: '正常浏览',
    desc: '认证无误后即可正常浏览。建议将页面加入收藏，下次仍从本页认证通道进入，保证始终访问正版。',
    icon: 'ri-eye-line',
  },
];

export interface FakeRow {
  field: string;
  real: string;
  fake: string;
}

export const fakeRows: FakeRow[] = [
  {
    field: '域名形态',
    real: '官方唯一域名，拼写规范、无多余字符',
    fake: '多字母、数字或易混字符拼接的近似域名',
  },
  {
    field: '认证角标',
    real: '红色封签式唯一认证标识，位置固定',
    fake: '缺少角标，或使用绿/蓝等其它色系的仿印',
  },
  {
    field: '页面气质',
    real: '干净轻壳、版式统一，无弹窗轰炸',
    fake: '弹窗广告密集，常引导下载第三方应用',
  },
  {
    field: '内容来源',
    real: '栏目齐备、信息有出处可循',
    fake: '通篇堆砌标题，无栏目结构、无出处',
  },
];

export interface TrustStat {
  value: string;
  label: string;
}

export const trustStats: TrustStat[] = [
  { value: '唯一', label: '官方认证站点，仅此一家正版入口' },
  { value: '7×24', label: '入口状态持续监测，异常即告警' },
  { value: '0', label: '未授权仿冒链接接入，全部拦截' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '如何判断我访问的是不是吃瓜官网正版？',
    a: '请认准页面右上角的红色封签式唯一认证角标，并在地址栏核对官方域名。凡是缺少认证角标，或域名存在多字母、易混字符拼接的站点，均不属于官方认证范围。',
  },
  {
    q: '官网入口为什么会定期更新？',
    a: '为保证访问速度与稳定性，同时降低被仿冒风险，官网会根据网络环境不定期切换正式访问通道。老地址会自动跳转至最新入口，不影响你的收藏使用。',
  },
  {
    q: '遇到打不开或页面空白怎么办？',
    a: '建议先清理浏览器缓存并关闭第三方加速工具，改用系统自带浏览器重试。若仍无法访问，可在本站任意认证提示区块联系官方，切勿前往来源不明的“修复教程”。',
  },
  {
    q: '官方认证标识会不会有变体？',
    a: '官方认证角标自发布起样式保持一致，仅有唯一一种红色封签形态。凡使用其它颜色、其它图案宣称官方认证的，均视为仿冒，请谨慎甄别。',
  },
  {
    q: '如何把官网分享给朋友又不会踩坑？',
    a: '最稳妥的方式是让对方从本页顶部按钮进入并自行确认认证角标，而非直接转发第三方链接。转发的入口经过仿冒站点的概率更高。',
  },
];